import * as amplitude from "@amplitude/analytics-browser";

const AMPLITUDE_API_KEY = "72707ff86b2c81a11d6e4cb069dc4fbe";

export const initAmplitude = () => {
  amplitude.init(AMPLITUDE_API_KEY, {
    defaultTracking: true, // Automatically tracks page views, clicks, etc.
    //serverZone: "EU",
  });
};

export const logEvent = (
  eventName: string,
  eventProperties?: Record<string, any>
) => {
  amplitude.track(eventName, eventProperties);
};

export const setUserId = (userId: string) => {
  amplitude.setUserId(userId);
};

export const setUserProperties = (properties: amplitude.Identify) => {
  amplitude.identify(properties);
};
